import { Component, HostListener, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MessageBeep } from 'src/app/wings-mobile/services/messageBeep/messageBeep.service';
import { ButtonDirective } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'outbound',
    templateUrl: './outbound.component.html',
    styleUrls: ['./outbound.component.css'],
    imports: [ButtonDirective, RouterLink, TranslatePipe]
})
export class OutboundComponent implements OnInit {

	constructor(public messageBeep: MessageBeep) {
		this.messageBeep = messageBeep;
	}

	barCode: string;

	cameraEnabled: boolean;

	availableDevices: MediaDeviceInfo[];
	currentDevice: MediaDeviceInfo = null;

	hasDevices: boolean;
	hasPermission: boolean;

	qrResultString: string;

	torchEnabled = false;
	torchAvailable$ = new BehaviorSubject<boolean>(false);
	tryHarder = false;

	ngOnInit() {
	}

	clearResult(): void {
		this.qrResultString = null;
	}

	onCamerasFound(devices: MediaDeviceInfo[]): void {
		this.availableDevices = devices;
		this.hasDevices = Boolean(devices && devices.length);
	}

	onCameraNotFound() {
		alert('Tu dispositivo no es compatible con cámara.');
	}

	onCodeResult(resultString: string) {
		this.messageBeep.successBeep();

		this.cameraEnabled = false;
		this.qrResultString = resultString;
		alert('El nro del codigo de barras es: ' + this.qrResultString);
	}

	onDeviceSelectChange(selected: string) {
		const device = this.availableDevices.find(x => x.deviceId === selected);
		this.currentDevice = device || null;
	}

	onHasPermission(has: boolean) {
		this.hasPermission = has;
	}

	onTorchCompatible(isCompatible: boolean): void {
		this.torchAvailable$.next(isCompatible || false);
	}

	toggleTorch(): void {
		this.torchEnabled = !this.torchEnabled;
	}

	toggleTryHarder(): void {
		this.tryHarder = !this.tryHarder;
	}

	@HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		this.barCode = event.key;
	}

	clearInput() {
		this.barCode = null;
	}
}

